import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  siteDashboardDetails,
  siteDashboardList,
  superDashboard,
} from "../../redux/api/dummyJson";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import PeopleIcon from "@mui/icons-material/People";
import BusinessIcon from "@mui/icons-material/Business";
import VideocamIcon from "@mui/icons-material/Videocam";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import { toast } from "react-toastify";

const CompanyDashboard = () => {
  const givenpermissions = JSON.parse(
    localStorage.getItem("user_permission") ?? "[]",
  );
  const navigate = useNavigate();
  const [dashboardList, setDashboardList] = useState({});

  const [name, setName] = useState("");
  const siteRef = useRef();
  const detailsRef = useRef();

  const [show, setShow] = useState({
    site: false,
    siteDetails: false,
  });

  useEffect(() => {
    if (detailsRef.current) {
      detailsRef.current.focus();
    }
  }, [show]);

  const handleNavigate = (id) => {
    console.log("id", id);
    switch (id) {
      case 1:
        navigate("/company-admin");
        break;
      case 2:
        setShow((prev) => ({ ...prev, siteDetails: !prev.siteDetails }));
        break;
      default:
        break;
    }
  };

  const getDashboard = () => {
    post(URL.USER_DASHBOARD, {})
      .then((res) => {
        if (res?.status == "success") {
          setDashboardList(res?.dashboard_datas);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const navigationHandler = (route, routeProb) => {
    if (route) navigate(route, { state: routeProb ?? {} });
  };

  useEffect(() => {
    getDashboard();
  }, []);

  const primaryColor = "#852e59";
  const cardShadow = "0 8px 20px rgba(0, 0, 0, 0.05)";
  const cardHoverShadow = "0 12px 28px rgba(0, 0, 0, 0.1)";
  const borderRadius = "20px";

  return (
    <div
      className="dashRightView "
      style={{ backgroundColor: "#ffffff", minHeight: "100vh" }}
    >
      <div className="d-flex flex-row flex-wrap gap-4 mt-3 pointer">
        <div
          onClick={() => {
            navigationHandler("/knf-company-admin-list");
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
                letterSpacing: "0.3px",
              }}
            >
              No of Admin
            </h4>
            <PeopleIcon style={{ color: primaryColor, fontSize: "28px" }} />
          </div>
          <h2 className="f3 my-2 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-24 ">
            {dashboardList?.company_admin_count}
          </h2>
        </div>
        <div
          onClick={() => {
            // navigationHandler("/company-sites");
            if (dashboardList?.site_details?.length === 0) {
              toast.info("No Sites Available");
            } else handleNavigate(2);
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Sites
            </h4>
            <LocationOnIcon style={{ color: "#4c9aff", fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.site_count}
          </h2>
        </div>
        <div
          onClick={() => {
            if (givenpermissions?.includes("CAN-List-KNF_COMPANY_CAMERA"))
              navigationHandler("/company-alert-types", { tab: "camera" });
            // handleNavigate(4);
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Camera Devices
            </h4>
            <VideocamIcon style={{ color: "#2d9cdb", fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.camera_count}
          </h2>
        </div>
        <div
          onClick={() => {
            navigationHandler("/company-notifications", { tab: "Recent" });
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of New Alerts
            </h4>
            <NotificationsActiveIcon
              style={{ color: "#f9a825", fontSize: "28px" }}
            />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.new_alert_count}
          </h2>
        </div>
        <div
          onClick={() => {
            navigationHandler("/company-notifications", { tab: "Allocated" });
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Allocated Alerts
            </h4>
            <AssignmentTurnedInIcon
              style={{ color: "#9c27b0", fontSize: "28px" }}
            />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.allocated_alert_count}
          </h2>
        </div>
        <div
          onClick={() => {
            navigationHandler("/company-notifications", { tab: "Closed" });
          }}
          className="my-3"
          style={{
            backgroundColor: "#ffffff",
            borderRadius: borderRadius,
            boxShadow: cardShadow,
            padding: "20px",
            minWidth: "180px",
            flex: "1 1 auto",
            cursor: "pointer",
            transition: "all 0.3s ease",
            border: `1px solid #f0eef0`,
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "translateY(-4px)")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.transform = "translateY(0)")
          }
        >
          <div className="d-flex align-items-center justify-content-between gap-3">
            <h4
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#6c6c6c",
                margin: 0,
              }}
            >
              No of Closed Alerts
            </h4>
            <DoneAllIcon style={{ color: "#43a047", fontSize: "28px" }} />
          </div>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: 700,
              color: "#2c2c2c",
              margin: "12px 0 0 0",
            }}
          >
            {dashboardList?.closed_alert_count}
          </h2>
        </div>
      </div>

      {show.siteDetails && (
        <>
          <hr className="border-t-2 border-gray-400 my-5" />
          <h4
            className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 "
            tabIndex={1}
            ref={detailsRef}
          >
            {`Site List `}
          </h4>

          <div className="d-flex ac-je">
            <button
              className="submit-btn"
              style={{ minWidth: "8%" }}
              onClick={() => setShow(false)}
            >
              Close
            </button>
          </div>
          <div className="row g-4 mt-2">
            {(dashboardList?.site_details ?? []).map((item) => (
              <div className="col-12 col-sm-6 col-lg-4" key={item.id}>
                <div
                  className="bg-white rounded-4 shadow-sm border h-100 p-3 d-flex flex-column justify-content-between"
                  style={{
                    transition: "0.3s",
                    minHeight: "320px",
                  }}
                >
                  <div>
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h5 className="f3 fw-bold primary mb-1">
                          {item.site_name}
                        </h5>

                        <p className="text-muted fw-semibold mb-0">
                          ({item.site_code})
                        </p>
                      </div>

                      <div className="bg-light rounded-3 p-2">
                        <HomeWorkIcon color="secondary" sx={{ fontSize: 32 }} />
                      </div>
                    </div>

                    {/* Stats */}
                    <div className="row g-2 mb-3">
                      <div className="col-6">
                        <div className="bg-light rounded-3 p-2 text-center">
                          <p className="text-muted mb-1 small fw-semibold">
                            Group 1
                          </p>
                          <h5 className="fw-bold mb-0">
                            {item?.statistics?.group1_users_count}
                          </h5>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="bg-light rounded-3 p-2 text-center">
                          <p className="text-muted mb-1 small fw-semibold">
                            Group 2
                          </p>
                          <h5 className="fw-bold mb-0">
                            {item?.statistics?.group2_users_count}
                          </h5>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="bg-light rounded-3 p-2 text-center">
                          <p className="text-muted mb-1 small fw-semibold">
                            Group 3
                          </p>
                          <h5 className="fw-bold mb-0">
                            {item?.statistics?.group3_users_count}
                          </h5>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="bg-light rounded-3 p-2 text-center">
                          <p className="text-muted mb-1 small fw-semibold">
                            Cameras
                          </p>
                          <h5 className="fw-bold mb-0">
                            {item?.statistics?.camera_count}
                          </h5>
                        </div>
                      </div>
                    </div>

                    {/* Alerts */}
                    <div className="d-flex gap-2 mb-3">
                      <div className="flex-fill bg-warning bg-opacity-10 rounded-3 p-2 text-center">
                        <p className="fw-semibold text-warning small mb-1">
                          New
                        </p>

                        <h6 className="fw-bold mb-0">
                          {item?.statistics?.new_alert_count}
                        </h6>
                      </div>

                      <div className="flex-fill bg-info bg-opacity-10 rounded-3 p-2 text-center">
                        <p className="fw-semibold text-info small mb-1">
                          Allocated
                        </p>

                        <h6 className="fw-bold mb-0">
                          {item?.statistics?.allocated_alert_count}
                        </h6>
                      </div>

                      <div className="flex-fill bg-success bg-opacity-10 rounded-3 p-2 text-center">
                        <p className="fw-semibold text-success small mb-1">
                          Closed
                        </p>

                        <h6 className="fw-bold mb-0">
                          {item?.statistics?.closed_alert_count}
                        </h6>
                      </div>
                    </div>
                  </div>

                  {/* Button */}
                  <button
                    className="submit-btn w-100 mt-2"
                    onClick={(e) => {
                      e.stopPropagation();

                      navigationHandler("/company-sites-view", {
                        type: "view",
                        data: { ...item, id: item?.site_id },
                      });
                    }}
                  >
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CompanyDashboard;
